import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// token操作
import { utilCookies } from '@/util/cookies';
import { getTax, saveTax } from '@/api/payroll/salary-scheme/detail';
import example from './example';
export default {
  components: {
    example: example
  },
  props: {
    activeObj: {
      type: Object
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isDisplay: {
      type: Boolean,
      default: false
    },
    // 工资计算中有使用该组件并传参数id
    id: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var str = utilCookies.getLanguage() || 'en';
    return {
      activeNames: this.isShow ? [0] : [],
      lang: str,
      activeInfo: this.activeObj ? this.activeObj.data.info : {
        extend: {
          cycle_hire_tax_strategy: {
            type: 1
          },
          cycle_leave_tax_strategy: {
            type: 1
          }
        }
      },
      cActiveInfo: this.activeObj ? this.activeObj.data.cInfo : {
        extend: {
          cycle_hire_tax_strategy: {
            type: 1
          },
          cycle_leave_tax_strategy: {
            type: 1
          }
        }
      } // 拷贝数据，判断是否修改
    };
  },

  computed: {
    url: function url() {
      var url = {
        3: 'https://www.flash-hr.com/blog/what-is-personal-income-tax-rate-and-how-to-calculate',
        // 个人所得税
        4: 'https://www.flash-hr.com/blog/withholding-tax-calculation' // 预扣税
      };

      if (this.lang !== 'th') {
        url[3] = "https://www.flash-hr.com/".concat(this.lang, "/blog/what-is-personal-income-tax-rate-and-how-to-calculate");
        url[4] = "https://www.flash-hr.com/".concat(this.lang, "/blog/withholding-tax-calculation");
      }
      return url;
    }
  },
  mounted: function mounted() {
    this.handleGetData();
  },
  methods: {
    handleViewExample: function handleViewExample() {
      this.$refs.example.visible = true;
    },
    handleGetData: function handleGetData() {
      var _this = this;
      getTax({
        payroll_sub_project_scheme_id: this.id || this.$route.params.id
      }).then(function (res) {
        _this.activeInfo = Object.assign(_this.activeInfo, res.data);
        _this.cActiveInfo = JSON.parse(JSON.stringify(_this.activeInfo));
      });
    },
    saveData: function saveData() {
      return saveTax(_objectSpread(_objectSpread({}, this.activeInfo), {}, {
        payroll_sub_project_scheme_id: this.id || this.$route.params.id
      }));
    }
  }
};